module.exports = __webpack_public_path__ + "static/social-be9fbc0de49cc8c67345fdc9f6415d9c.svg";